var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actData)?_c('section',{class:['city-location', _vm.isXl && 'xl'],style:(_vm.styleObj)},[_c('p',[_c('img',{attrs:{"src":require("../assets/images/city_location.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.cityName))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }